import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

// In its own module so the operation name matches the filename, as required by
// the `consistent-graphql-operation-naming` lint rule.
export const approvalActivityHistoryQuery: GraphQLTaggedNode = graphql`
	query ApprovalActivityHistoryQuery(
		$cloudId: ID!
		$contentId: ID!
		$first: Int = 20
		$after: String
		$contentStatuses: [GraphQLContentStatus]!
	) {
		confluence_workflowApplicationHistory(
			cloudId: $cloudId
			contentId: $contentId
			first: $first
			after: $after
			contentStatuses: $contentStatuses
		) {
			edges {
				cursor
				node {
					id
					workflowApplicationId
					workflowReviewId
					contentId
					contentVersion
					contentStatus
					action
					triggerSource
					creationDate {
						value
					}
					actor {
						accountId
						displayName
					}
					targetPrincipal {
						principalType
						principalId
					}
					reviewDecision {
						decisionStatus
						comment
					}
					workflowStatus {
						id
						allowsReviews
						displayProperties {
							name
							description
							color
							icon
						}
					}
				}
			}
			pageInfo {
				endCursor
				hasNextPage
			}
		}
	}
`;
